import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-12 lg:gap-x-5" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-6 sm:px-6 lg:col-span-9 md:max-w-xl mx-auto lg:px-0"
}
const _hoisted_3 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_4 = {
  key: 0,
  class: "space-y-6 bg-white px-4 py-6 sm:p-6"
}
const _hoisted_5 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_6 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_7 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_8 = { class: "w-full flex justify-center mt-5" }
const _hoisted_9 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_10 = { class: "mt-2 text-sm text-gray-500" }
const _hoisted_11 = { class: "w-full mt-5" }
const _hoisted_12 = {
  for: "title",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_13 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "title-error"
}
const _hoisted_16 = { class: "w-full flex justify-center mt-5" }
const _hoisted_17 = {
  type: "submit",
  class: "relative inline-flex items-center gap-x-1.5 mr-3 rounded-md bg-royal-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-blue-500 cursor-pointer"
}
const _hoisted_18 = {
  key: 1,
  class: "space-y-6 sm:px-6 lg:col-span-9 lg:px-0"
}
const _hoisted_19 = { class: "relative sm:border-b border-gray-200 pb-0 sm:pb-0" }
const _hoisted_20 = { class: "mt-4" }
const _hoisted_21 = { class: "sm:block" }
const _hoisted_22 = { class: "-mb-px flex space-x-4" }
const _hoisted_23 = ["onClick", "aria-current"]
const _hoisted_24 = {
  key: 0,
  class: "ms-2 inline-flex items-center rounded-full bg-gray-300 px-1.5 py-0.5 text-xs font-medium text-gray-600 inset-ring inset-ring-gray-500/10"
}
const _hoisted_25 = { class: "md:flex md:items-center md:justify-between" }
const _hoisted_26 = {
  key: 0,
  class: "w-full sm:w-auto mt-3 inline-flex gap-2 md:absolute md:top-0 md:right-0 md:mt-0"
}
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_29 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_30 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_31 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_32 = {
  key: 0,
  class: "grid grid-cols-6 gap-6"
}
const _hoisted_33 = { class: "col-span-6 grid grid-cols-4 gap-6" }
const _hoisted_34 = { class: "col-span-4 sm:col-span-2" }
const _hoisted_35 = {
  for: "avatar",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_36 = { class: "col-span-4 sm:col-span-2" }
const _hoisted_37 = { class: "inline-flex items-center w-full justify-between" }
const _hoisted_38 = {
  for: "cover-photo",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_39 = { class: "col-span-6" }
const _hoisted_40 = {
  for: "title",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_41 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_42 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "title-error"
}
const _hoisted_43 = { class: "col-span-6" }
const _hoisted_44 = {
  for: "username",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_45 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_46 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "name-error"
}
const _hoisted_47 = { class: "mt-1 text-sm/6 text-gray-400" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "font-medium text-gray-600" }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "mt-1 text-sm/6 text-gray-400" }
const _hoisted_52 = { class: "col-span-full" }
const _hoisted_53 = {
  for: "description",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_54 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_55 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "description-error"
}
const _hoisted_56 = { class: "mt-1 text-sm/6 text-gray-400" }
const _hoisted_57 = { class: "col-span-full" }
const _hoisted_58 = {
  for: "prices_block_title",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_59 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_60 = ["placeholder"]
const _hoisted_61 = { class: "mt-1 text-sm/6 text-gray-400" }
const _hoisted_62 = { class: "col-span-full" }
const _hoisted_63 = {
  for: "locale",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_64 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_65 = { value: "uk" }
const _hoisted_66 = { value: "en" }
const _hoisted_67 = { value: "cz" }
const _hoisted_68 = { value: "de" }
const _hoisted_69 = { value: "es" }
const _hoisted_70 = { value: "fr" }
const _hoisted_71 = { value: "it" }
const _hoisted_72 = { value: "pl" }
const _hoisted_73 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "locale-error"
}
const _hoisted_74 = { class: "bg-gray-50 px-4 py-3 text-right sm:px-6" }
const _hoisted_75 = {
  type: "submit",
  class: "inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer"
}
const _hoisted_76 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_77 = { class: "space-y-6 bg-white px-4 py-6 sm:p-6" }
const _hoisted_78 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_79 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_80 = { class: "text-gray-400" }
const _hoisted_81 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_82 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_83 = {
  for: "phone_number",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_84 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_85 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "phone_number-error"
}
const _hoisted_86 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_87 = {
  for: "email",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_88 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_89 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_90 = { class: "mt-1 text-sm/6 text-gray-400" }
const _hoisted_91 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_92 = {
  for: "location",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_93 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_94 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "location-error"
}
const _hoisted_95 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_96 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_97 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "instagram_url-error"
}
const _hoisted_98 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_99 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_100 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "facebook_url-error"
}
const _hoisted_101 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_102 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_103 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "telegram_url-error"
}
const _hoisted_104 = { class: "col-span-6 sm:col-span-6" }
const _hoisted_105 = {
  for: "website_url",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_106 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_107 = ["placeholder"]
const _hoisted_108 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "website_url-error"
}
const _hoisted_109 = { key: 3 }
const _hoisted_110 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControlsMenuComponent = _resolveComponent("ControlsMenuComponent")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_ShareProfileModalComponent = _resolveComponent("ShareProfileModalComponent")!
  const _component_AvatarComponent = _resolveComponent("AvatarComponent")!
  const _component_CoverUploaderComponent = _resolveComponent("CoverUploaderComponent")!
  const _component_UserDescriptionEditor = _resolveComponent("UserDescriptionEditor")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_PortfolioSection = _resolveComponent("PortfolioSection")!
  const _component_PricesSection = _resolveComponent("PricesSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ControlsMenuComponent),
    (!_ctx.profile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.isCreatingProfile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('profile.title')), 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('profile.creating_tip')), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('profile.creating_tip_2')), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isCreatingProfile = true), ["prevent"])),
                        class: "relative inline-flex items-center gap-x-1.5 mr-3 rounded-md bg-royal-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-blue-500 cursor-pointer"
                      }, "Створити профіль")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isCreatingProfile)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 1,
                  onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
                  class: "space-y-6 bg-white px-4 py-6 sm:p-6"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('profile.creating_title')), 1),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('profile.creating_text')), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('profile.name')), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          id: "title",
                          name: "title",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.title) = $event)),
                          placeholder: _ctx.user.name,
                          type: "text",
                          autocomplete: "title",
                          class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('title')
                                        })
                        }, null, 10, _hoisted_14), [
                          [_vModelText, _ctx.form.title]
                        ]),
                        (_ctx.hasError('title'))
                          ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                              key: 0,
                              class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                              "aria-hidden": "true"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.hasError('title'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.getError('title')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", _hoisted_17, _toDisplayString(_ctx.$t('profile.continue')), 1)
                    ])
                  ])
                ], 32))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.profile && _ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (_ctx.profile && _ctx.profile.public_url)
            ? (_openBlock(), _createBlock(_component_ShareProfileModalComponent, {
                key: 0,
                open: _ctx.showShareModal,
                url: _ctx.profile.public_url,
                "qr-url": _ctx.publicUrl(`qr-code/share?size=500&url=${_ctx.profile.public_url}`),
                name: _ctx.profile.title,
                onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showShareModal = false))
              }, null, 8, ["open", "url", "qr-url", "name"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("nav", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: tab.name,
                      href: "#",
                      onClick: _withModifiers(($event: any) => (_ctx.activeTab = tab.id), ["prevent"]),
                      class: _normalizeClass([
                                   tab.id == _ctx.activeTab
                                   ? 'border-blue-600 text-blue-700'
                                   : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',

                                   'border-b-2 px-1 pb-4 text-sm font-medium whitespace-nowrap'
                               ]),
                      "aria-current": tab.id == _ctx.activeTab ? 'page' : undefined
                    }, [
                      _createElementVNode("span", null, _toDisplayString(tab.name), 1),
                      (tab.id == 'prices')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, "New"))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_23))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              (_ctx.profile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("a", {
                      href: _ctx.profile.public_url,
                      target: "_blank",
                      class: "flex-1 sm:flex-none inline-flex justify-center items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50"
                    }, _toDisplayString(_ctx.$t('profile.view_profile')), 9, _hoisted_27),
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.showShareModal = true), ["prevent"])),
                      class: "flex-1 sm:flex-none inline-flex justify-center items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 cursor-pointer"
                    }, _toDisplayString(_ctx.$t('profile.share_profile')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.activeTab == 'main')
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args)), ["prevent"])),
                enctype: "multipart/form-data"
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.$t('profile.general_title')), 1),
                      _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('profile.view_profile')), 1)
                    ]),
                    (_ctx.profile)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('profile.avatar')), 1),
                              _createVNode(_component_AvatarComponent, {
                                class: "mt-2",
                                current_url: _ctx.form.avatar_url
                              }, null, 8, ["current_url"])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('profile.cover')), 1),
                                (_ctx.form?.cover?.uploaded)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteCover && _ctx.deleteCover(...args)), ["prevent"])),
                                      class: "text-xs text-gray-500 hover:text-red-600 cursor-pointer hover:underline"
                                    }, _toDisplayString(_ctx.$t('profile.delete_cover')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.form.cover)
                                ? (_openBlock(), _createBlock(_component_CoverUploaderComponent, {
                                    key: 0,
                                    height: 100,
                                    position: _ctx.form.cover.position,
                                    cover_url: (_ctx.form.cover.uploaded && _ctx.form.cover.url) ? _ctx.form.cover.url : undefined,
                                    preview_url: _ctx.cover.preview_url || undefined,
                                    is_file_selected: _ctx.cover.file !== null,
                                    is_file_uploading: _ctx.cover.is_uploading,
                                    onPositionUpdated: _ctx.coverPositionsUpdated,
                                    onCoverFileSelected: _ctx.selectCoverFile
                                  }, null, 8, ["position", "cover_url", "preview_url", "is_file_selected", "is_file_uploading", "onPositionUpdated", "onCoverFileSelected"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('profile.name')), 1),
                            _createElementVNode("div", _hoisted_41, [
                              _withDirectives(_createElementVNode("input", {
                                id: "title",
                                name: "title",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.title) = $event)),
                                type: "text",
                                autocomplete: "title",
                                class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('title')
                                        })
                              }, null, 2), [
                                [_vModelText, _ctx.form.title]
                              ]),
                              (_ctx.hasError('title'))
                                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                    key: 0,
                                    class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.hasError('title'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.getError('title')), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('profile.address')), 1),
                            _createElementVNode("div", _hoisted_45, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "username",
                                id: "username",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.username) = $event)),
                                class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('username')
                                        }),
                                placeholder: "janesmith"
                              }, null, 2), [
                                [_vModelText, _ctx.form.username]
                              ]),
                              (_ctx.hasError('username'))
                                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                    key: 0,
                                    class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.hasError('username'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.getError('username')), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_47, [
                              (_ctx.form.username)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('profile.your_address')) + " ", 1),
                                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.form.username) + ".gallera.io", 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_50))
                            ]),
                            _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.$t('profile.address_tip')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('profile.description')), 1),
                            _createElementVNode("div", _hoisted_54, [
                              _createVNode(_component_UserDescriptionEditor, {
                                modelValue: _ctx.form.description,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.description) = $event)),
                                class: _normalizeClass({ 'is-invalid': _ctx.hasError('description') })
                              }, null, 8, ["modelValue", "class"]),
                              (_ctx.hasError('description'))
                                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                    key: 0,
                                    class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.hasError('description'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(_ctx.getError('description')), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t('profile.description_tip')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('profile.prices_block_title_label')), 1),
                            _createElementVNode("div", _hoisted_59, [
                              _withDirectives(_createElementVNode("input", {
                                id: "prices_block_title",
                                name: "prices_block_title",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.prices_block_title) = $event)),
                                type: "text",
                                autocomplete: "off",
                                placeholder: _ctx.$t('profile.prices_title'),
                                class: "block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                              }, null, 8, _hoisted_60), [
                                [_vModelText, _ctx.form.prices_block_title]
                              ])
                            ]),
                            _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.$t('profile.prices_block_title_tip')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('gallery_settings.general.language')), 1),
                            _createElementVNode("div", _hoisted_64, [
                              _withDirectives(_createElementVNode("select", {
                                id: "locale",
                                name: "locale",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.locale) = $event)),
                                class: _normalizeClass({
                                            'col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('locale')
                                        })
                              }, [
                                _createElementVNode("option", _hoisted_65, _toDisplayString(_ctx.$t('gallery_settings.general.languages.ukrainian')), 1),
                                _createElementVNode("option", _hoisted_66, _toDisplayString(_ctx.$t('gallery_settings.general.languages.english')), 1),
                                _createElementVNode("option", _hoisted_67, _toDisplayString(_ctx.$t('gallery_settings.general.languages.czech')), 1),
                                _createElementVNode("option", _hoisted_68, _toDisplayString(_ctx.$t('gallery_settings.general.languages.german')), 1),
                                _createElementVNode("option", _hoisted_69, _toDisplayString(_ctx.$t('gallery_settings.general.languages.spanish')), 1),
                                _createElementVNode("option", _hoisted_70, _toDisplayString(_ctx.$t('gallery_settings.general.languages.french')), 1),
                                _createElementVNode("option", _hoisted_71, _toDisplayString(_ctx.$t('gallery_settings.general.languages.italian')), 1),
                                _createElementVNode("option", _hoisted_72, _toDisplayString(_ctx.$t('gallery_settings.general.languages.polish')), 1)
                              ], 2), [
                                [_vModelSelect, _ctx.form.locale]
                              ]),
                              _createVNode(_component_ChevronDownIcon, {
                                class: "pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4",
                                "aria-hidden": "true"
                              }),
                              (_ctx.hasError('locale'))
                                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                    key: 0,
                                    class: "pointer-events-none col-start-1 row-start-1 mr-8 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                    "aria-hidden": "true"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.hasError('locale'))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(_ctx.getError('locale')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("button", _hoisted_75, _toDisplayString(_ctx.$t('profile.save')), 1)
                  ])
                ])
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.activeTab == 'contacts')
            ? (_openBlock(), _createElementBlock("form", {
                key: 2,
                onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args)), ["prevent"])),
                enctype: "multipart/form-data"
              }, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_78, _toDisplayString(_ctx.$t('profile.contacts')), 1),
                      _createElementVNode("p", _hoisted_79, [
                        _createTextVNode(_toDisplayString(_ctx.$t('profile.contacts_tip')) + " ", 1),
                        _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.$t('profile.contacts_tip_2')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t('profile.phone')), 1),
                        _createElementVNode("div", _hoisted_84, [
                          _withDirectives(_createElementVNode("input", {
                            id: "phone_number",
                            name: "phone_number",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.phone_number) = $event)),
                            type: "text",
                            autocomplete: "phone",
                            class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('phone_number')
                                        })
                          }, null, 2), [
                            [_vModelText, _ctx.form.phone_number]
                          ]),
                          (_ctx.hasError('phone_number'))
                            ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                key: 0,
                                class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                "aria-hidden": "true"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.hasError('phone_number'))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_85, _toDisplayString(_ctx.getError('phone_number')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('profile.email')), 1),
                        _createElementVNode("div", _hoisted_88, [
                          _withDirectives(_createElementVNode("input", {
                            id: "email",
                            name: "email",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.email) = $event)),
                            type: "email",
                            autocomplete: "email",
                            class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('email')
                                        })
                          }, null, 2), [
                            [_vModelText, _ctx.form.email]
                          ]),
                          (_ctx.hasError('email'))
                            ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                key: 0,
                                class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                "aria-hidden": "true"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.hasError('email'))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_89, _toDisplayString(_ctx.getError('email')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_90, _toDisplayString(_ctx.$t('profile.email_tip')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t('profile.location')), 1),
                        _createElementVNode("div", _hoisted_93, [
                          _withDirectives(_createElementVNode("input", {
                            id: "location",
                            name: "location",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.location) = $event)),
                            type: "text",
                            autocomplete: "location",
                            placeholder: "Київ, Україна",
                            class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('location')
                                        })
                          }, null, 2), [
                            [_vModelText, _ctx.form.location]
                          ]),
                          (_ctx.hasError('location'))
                            ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                key: 0,
                                class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                "aria-hidden": "true"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.hasError('location'))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_94, _toDisplayString(_ctx.getError('location')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", {
                          for: "instagram_url",
                          class: "block text-sm/6 font-medium text-gray-900"
                        }, "Instagram", -1)),
                        _createElementVNode("div", _hoisted_96, [
                          _withDirectives(_createElementVNode("input", {
                            id: "instagram_url",
                            name: "instagram_url",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.instagram_url) = $event)),
                            type: "text",
                            autocomplete: "instagram_url",
                            class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('instagram_url')
                                        })
                          }, null, 2), [
                            [_vModelText, _ctx.form.instagram_url]
                          ]),
                          (_ctx.hasError('instagram_url'))
                            ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                key: 0,
                                class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                "aria-hidden": "true"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.hasError('instagram_url'))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(_ctx.getError('instagram_url')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", {
                          for: "facebook_url",
                          class: "block text-sm/6 font-medium text-gray-900"
                        }, "Facebook", -1)),
                        _createElementVNode("div", _hoisted_99, [
                          _withDirectives(_createElementVNode("input", {
                            id: "facebook_url",
                            name: "facebook_url",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.facebook_url) = $event)),
                            type: "text",
                            autocomplete: "facebook_url",
                            class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('facebook_url')
                                        })
                          }, null, 2), [
                            [_vModelText, _ctx.form.facebook_url]
                          ]),
                          (_ctx.hasError('facebook_url'))
                            ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                key: 0,
                                class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                "aria-hidden": "true"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.hasError('facebook_url'))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_100, _toDisplayString(_ctx.getError('facebook_url')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_101, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", {
                          for: "telegram_url",
                          class: "block text-sm/6 font-medium text-gray-900"
                        }, "Telegram", -1)),
                        _createElementVNode("div", _hoisted_102, [
                          _withDirectives(_createElementVNode("input", {
                            id: "telegram_url",
                            name: "telegram_url",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.telegram_url) = $event)),
                            type: "text",
                            autocomplete: "telegram_url",
                            class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('telegram_url')
                                        })
                          }, null, 2), [
                            [_vModelText, _ctx.form.telegram_url]
                          ]),
                          (_ctx.hasError('telegram_url'))
                            ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                key: 0,
                                class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                "aria-hidden": "true"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.hasError('telegram_url'))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_103, _toDisplayString(_ctx.getError('telegram_url')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_104, [
                        _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t('profile.website')), 1),
                        _createElementVNode("div", _hoisted_106, [
                          _withDirectives(_createElementVNode("input", {
                            id: "website_url",
                            name: "website_url",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.website_url) = $event)),
                            type: "text",
                            autocomplete: "website_url",
                            placeholder: _ctx.user ? `https://${_ctx.user.username}.gallera.io` : 'https://username.gallera.io',
                            class: _normalizeClass({
                                            'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6': true,
                                            'col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 pl-3 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6': _ctx.hasError('website_url')
                                        })
                          }, null, 10, _hoisted_107), [
                            [_vModelText, _ctx.form.website_url]
                          ]),
                          (_ctx.hasError('website_url'))
                            ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                key: 0,
                                class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                                "aria-hidden": "true"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.hasError('website_url'))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_108, _toDisplayString(_ctx.getError('website_url')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "bg-gray-50 px-4 py-3 text-right sm:px-6" }, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "inline-flex justify-center rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-600 focus:outline-hidden cursor-pointer"
                    }, "Зберегти")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.activeTab == 'portfolio')
            ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                _createVNode(_component_PortfolioSection, { profile: _ctx.profile }, null, 8, ["profile"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeTab == 'prices')
            ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                _createVNode(_component_PricesSection)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}